<template>
  <UButton
    v-if="currentForm !== 'login'"
    color="white"
    size="xs"
    class="mb-4 pl-2 pr-2.5 gap-1"
    variant="solid"
    closable
    @click="currentForm = 'login'"
  >
    <UIcon class="-mr-0.5" name="mdi:arrow-left-thin" />
    {{ $t("components.aLoginForm.goBack") }}
  </UButton>

  <ALoginForm
    v-if="currentForm === 'login'"
    v-bind="{ ...allFormProps, ...loginFormProps }"
    @error="retrieveAccountOnLoginError"
    @password-forgotten="currentForm = 'forgot-password'"
  />

  <ARegisterForm
    v-if="currentForm === 'register'"
    v-bind="{ ...allFormProps, ...registerFormProps }"
  />

  <AForgotPasswordForm
    v-if="currentForm === 'forgot-password'"
    v-bind="allFormProps"
  />

  <div
    v-if="currentForm !== 'register' && canRegister"
    class="justify-center flex items-center flex-col text-sm sm:space-x-1 w-full mt-4"
  >
    <p>{{ $t("components.aLoginForm.dontHaveAccountYet") }}</p>
    <UButton
      data-test="register-button"
      color="primary"
      variant="link"
      :padded="false"
      class="justify-center font-bold"
      size="sm"
      @click="currentForm = 'register'"
    >
      {{ $t("components.aLoginForm.createAccount") }}
    </UButton>
  </div>
</template>

<script setup lang="ts">
import type { AAuthFormProps } from '#common/types'

withDefaults(defineProps<AAuthFormProps>(), {
  allFormProps: () => ({}),
  canRegister: false,
  loginFormProps: () => ({}),
  registerFormProps: () => ({}),
  socialProviders: () => [],
})

const currentForm = ref<'forgot-password' | 'login' | 'register'>('login')

const { retrieveAccountOnLoginError } = useRetrieveAccountStore()
</script>
